export default __webpack_public_path__ + "static/media/0l.955a04e6.png";